import React, { Component } from 'react';
import './ObdServiceButton.css';

import { Select, Icon } from 'antd';
import { inject, observer } from 'mobx-react';

import { Modal } from 'antd';

const CAMPAIGN_VALUES = ['active', 'listen', 'shutdown'];

@inject('translationsStore')
@observer
export default class ObdServiceButton extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {
    if (!!this.props.obdService && !!this.props.obdService.current && !!this.props.obdService.next) {
      const { current, next } = this.state.obdService;
      this.setState({ current, next });
    }
    if (!!this.props.offer) {
      this.setState({ offer: this.props.offer.toLowerCase() });
    }
  }

  static getDerivedStateFromProps(props, state) {
    let _state = null;
    if (!!props.obdService && (props.obdService.current !== state.current || props.obdService.next !== state.next)) {
      _state = {
        ...state,
        current: props.obdService.current,
        next: props.obdService.next
      };
    }

    if (props.offer !== state.offer) {
      _state = {
        ..._state,
        offer: props.offer.toLowerCase()
      };
    }
    return _state;
  }

  onChange = service => {
    const { translationsStore } = this.props;
    Modal.confirm({
      title: translationsStore.translate(`carView.obdservice.safe.confirm.title`),
      content: (
        <div>
          <div>{translationsStore.translate(`carView.obdservice.${this.getOfferLabel({ current: service })}.confirm.to${service}`)}</div>
          <div>{translationsStore.translate(`carView.obdservice.safe.confirm.content`)}</div>
        </div>
      ),
      onOk: () => this.props.onChange(service)
    });
  };

  getOfferLabel = ({ current = this.state.current, offer = this.state.offer } = { ...this.state }) => {
    return offer === 'full' && current === 'active' ? 'full' : 'safe';
  };

  render() {
    const { translationsStore, loading } = this.props;
    const { current, next } = this.state;

    return (
      <div className="ObdServiceButton">
        {loading && <Icon type="sync" spin />}
        {!!current && current === next && !loading && (
          <Select value={`${current}`} onChange={this.onChange} size="small" dropdownClassName="ObdServiceButtonSelectDropdown" dropdownMatchSelectWidth={false}>
            {CAMPAIGN_VALUES.sort((opt1, opt2) => {
              if (opt1 === current) {
                return -1;
              }
              if (opt2 === current) {
                return 1;
              }
              return 0;
            }).map(opt => (
              <Select.Option key={opt} value={opt} disabled={opt === current}>
                {translationsStore.translate(`carView.obdservice.${this.getOfferLabel({ current: opt })}.select.${opt === current ? 'selected' : 'option'}.${opt}`)}
              </Select.Option>
            ))}
          </Select>
        )}
        {!!current && current !== next && !loading && (
          <div className="inProgress">
            <div>{translationsStore.translate(`carView.obdservice.${this.getOfferLabel({ current: next })}.inprogress.${next}`)}</div>
            <Icon type="sync" spin />
          </div>
        )}
      </div>
    );
  }
}
